export const GetStatusChooser = () => {
    return ([
        { id: 0, name: 'Choisissez' },
        { id: 'Enable', name: 'Enable' },
        { id: 'Disable', name: 'Disable' },
    ])
}